module.exports = __webpack_public_path__ + "static/media/MTL_SL_MANGANESE1.76fa9fe7.png";